import { I18n } from "@assets/strings";
import React from "react";
import styled from "styled-components";
import { mobile } from "@ui/styles/utils";

export interface EmptyTableProps {
	disbursement?: boolean;
	source?: string;
}

export const EmptyTable: React.FC<EmptyTableProps> = ({ disbursement = false, source }) => {
	return (
		<Container>
			<img src={source} width="250px" height="250px" />
			<EmptyMessage>
				{!disbursement
					? I18n.t("shareroom.dashboard.transactions.table.null")
					: I18n.t("shareroom.dashboard.transactions.cashout.null")}
			</EmptyMessage>
		</Container>
	);
};

const Container = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	margin-bottom: 80px;
`;
const EmptyMessage = styled.div`
	font-weight: 400;
	font-size: 16px;
	line-height: 26px;
	color: rgba(1, 1, 1, 0.5);
	margin-top: 20px;
	@media ${mobile} {
		font-size: 13px;
	}
`;
